<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading"><Loader /></div>
        <leave-table
            :leaves="leaves"
            :filter="filter"
            :refresh="fetchData"
            v-else
        />
      </div>
    </div>
  </div>
</template>

<script>
import LeaveTable from "./components/LeaveTable.vue";
import Loader from "./components/Loader.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import {fetchLeaves} from "../api/services/leave";
const isLoading = ref(false);
const leaves = ref([]);
export default {
  name: "leaves",
  components: {
    LeaveTable,
    Loader,
  },
  setup() {
    const fetchData = async (filter, page) => {
      isLoading.value = true;
      //console.log(filter);
      try {
        const response = await fetchLeaves(filter, page);
        leaves.value = response.data;
        isLoading.value = false;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };
    onMounted(() => {
      const route = useRoute();
      const entity_params = ref();
      entity_params.value = {
        insurance_id: route.params?.insurance_id,
      };
      fetchData(entity_params, 1);
    });
    return {
      fetchData,
      leaves,
      isLoading,
    };
  },
};
</script>
